import { type Process } from "@certa/studio-core";
import {
  ComponentType,
  getWebGLFieldNodeIdFromComponentId,
  getWebGLSwimlaneNodeIdFromComponentId,
  getWebGLStepNodeIdFromComponentId
} from "@certa/process-designer";
import { StudioNodeType } from "../useStudioAPI.types";
import type { DeepReadonly } from "@certa/types";

export const generateNodeData = (
  componentId: string,
  componentType: ComponentType | null,
  process: DeepReadonly<Process>
) => {
  if (!componentType) return undefined;

  if (componentType === ComponentType.FIELD) {
    return process.fields[componentId];
  } else if (componentType === ComponentType.STEP) {
    return process.steps[componentId];
  } else if (componentType === ComponentType.SWIMLANE) {
    const swimlane = process.swimlanes[componentId];
    if (!swimlane) return undefined;
    return {
      ...swimlane,
      steps: swimlane.steps.map(stepId => process.steps[stepId])
    };
  } else return undefined;
};

export const getWebGLNodeId = (componentId: string, type: StudioNodeType) => {
  switch (type) {
    case StudioNodeType.FIELD:
      return getWebGLFieldNodeIdFromComponentId(componentId);
    case StudioNodeType.STEP:
      return getWebGLStepNodeIdFromComponentId(componentId);
    case StudioNodeType.SWIMLANE:
      return getWebGLSwimlaneNodeIdFromComponentId(componentId);
    default:
      return undefined;
  }
};
